import { render, staticRenderFns } from "./SiteAdminsAdd.vue?vue&type=template&id=c5274eb6&scoped=true&"
import script from "./SiteAdminsAdd.vue?vue&type=script&lang=js&"
export * from "./SiteAdminsAdd.vue?vue&type=script&lang=js&"
import style0 from "./SiteAdminsAdd.vue?vue&type=style&index=0&id=c5274eb6&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c5274eb6",
  null
  
)

export default component.exports